import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  useDeclineVendorPayment,
  useDeleteVendorPayment,
} from '../../../redux/spend-management/vendor/hook'
import { PAGINATION_DEFAULT, basicStatusConfig } from '../../../utils/constants'
import DataTable from '../../../components/datatable'
import { useGetInvoicePaySummary } from '../../../redux/spend-management/invoice-received/hook'

export const InvoicePaySummaryTab = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const { data: invoicePay } = useGetInvoicePaySummary(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )

  const { mutateAsync: declinePayment } = useDeclineVendorPayment()
  const { mutateAsync: deletePayment } = useDeleteVendorPayment()

  const history = useHistory()

  function Continue(id, type) {
    let index = invoicePay.data.findIndex((item) => item.id === id)
    if (index !== -1) {
      if (type === 'preview') {
        history.push(`/vendor/pay/preview/${invoicePay.data[index].id}`)
      } else if (type === 'view') {
        history.push(`/vendor/invoice/pay/view/${invoicePay.data[index].id}`)
      } else if (type === 'approve') {
        history.push(
          `/vendor/pay/preview/${invoicePay.data[index].id}?approve=true`
        )
      } else if (type === 'decline') {
        declinePayment(invoicePay.data[index].ref)
      } else if (type === 'delete') {
        deletePayment(invoicePay.data[index].ref)
      }
    }
  }

  const statusConfig = [
    {
      label: 'In Progress',
      color: 'orange',
      value: 0,
    },
    {
      label: 'Completed',
      color: 'green',
      value: 1,
    },
    {
      label: 'Awaiting Approval',
      color: 'orange',
      value: 2,
    },
    {
      label: 'Scheduled',
      color: 'orange',
      value: 3,
    },
    {
      label: 'Declined',
      color: 'red',
      value: 4,
    },
  ]

  const tableConfig = {
    headers: [
      'Invoice Date',
      'Vendor Name',
      'Mobile',
      'Due Date',
      'Invoice #',
      'Total Amount',
      'Status',
    ],
    keys: [
      'formatted_invoice_date',
      'vendor',
      'vendor_mobile',
      'formatted_invoice_due_date',
      'invoice_number',
      'formatted_total_amount',
      'status',
    ],
    mobileHeader: {
      left: {
        title: 'Vendor Name',
        key: 'vendor_name',
      },
      right: {
        title: 'Total Amount',
        key: 'total_amount',
      },
    },
  }

  const actionConfig = [
    // {
    //   name: 'Continue',
    //   color: 'green',
    //   action: (id) => {
    //     Continue(id, 'preview')
    //   },
    // },
    {
      name: 'View',
      color: 'green',
      action: (id) => {
        Continue(id, 'view')
      },
    },
    // {
    //   name: 'Delete',
    //   color: 'red',
    //   action: (id) => {
    //     Continue(id, 'delete')
    //   },
    // },
    // {
    //   name: 'Approve',
    //   color: 'green',
    //   action: (id) => {
    //     Continue(id, 'approve')
    //   },
    // },
    // {
    //   name: 'Decline',
    //   color: 'red',
    //   action: (id) => {
    //     Continue(id, 'decline')
    //   },
    // },
  ]

  return (
    <div className='flex flex-col bg-white rounded'>
      <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
        <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full'>
          Invoice Payments
        </div>
      </div>
      <hr className='divider mt-2 mb-2' />
      <DataTable
        data={invoicePay}
        tableConfig={tableConfig}
        statusConfig={statusConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        filterByStatus={basicStatusConfig}
        searchData={true}
        computedActions={true}
      />
    </div>
  )
}
